<footer class="om-footer mx-sm-2 mx-md-0">
    <div class="foot-top">
        <div class="container-fluid pt-3 pt-sm-5 p-4 colorBlue border16 pb-0">
            <div class="row mobile-view-row">
                <div class="col-md-8 col-sm-8 col-12 mobile-col-md-8 remove-padd-mob">
                    <div class="row justify-content-between mobile-footer-layout">
                        <div class="col-md-4 col-sm-9 col-12 remove-padd-mob">
                            <div class="row justify-content-between">
                                <!-- <div class="col-md-3 col-sm-6 col-6">
                                    <h6 class="foot-title-head">Knowledge Centre</h6>
                                    <ul class="footer-menu">
                                        <li><a href="">Knowledge Centre 1 </a></li>
                                        <li><a href="">Knowledge Centre 2 </a></li>
                                        <li><a href="">Knowledge Centre 3 </a></li>
                                        <li><a href="">Knowledge Centre 4 </a></li>
                                        <li><a href="">Knowledge Centre 5 </a></li>

                                    </ul>
                                </div> -->
                                <!-- <div class="col-md-3 col-sm-6 col-6">
                                    <h6 class="foot-title-head">India Trade Events</h6>
                                    <ul class="footer-menu">
                                        <li><a href="">Events 1 </a></li>
                                        <li><a href="">Events 2 </a></li>
                                        <li><a href="">Events 3 </a></li>
                                        <li><a href="">Events 4 </a></li>
                                        <li><a href="">Events 5 </a></li>
                                    </ul>
                                </div> -->
                                <!-- <div class="col-md-3 col-sm-6 col-6">
                                    <h6 class="foot-title-head">Alliances</h6>
                                    <ul class="footer-menu">
                                        <li><a href="">Alliances 1 </a></li>
                                        <li><a href="">Alliances 2 </a></li>
                                        <li><a href="">Alliances 3 </a></li>
                                        <li><a href="">Alliances 4 </a></li>
                                        <li><a href="">Alliances 5 </a></li>

                                    </ul>
                                </div> -->
                                <div class="col-md-12 col-sm-12 col-12">
                                    <h6 class="foot-title-head">Quick Links</h6>
                                    <ul class="footer-menu">
                                        <!-- <li class="clickable"><a (click)="navigateToHelpCenter()">Help Center</a></li> -->
                                        <!-- <li class="clickable"><a (click)="Feedbacks()">Feedbacks</a></li> -->
                                        <!-- <li class="clickable"><a (click)="Complaints()">Complaints</a></li> -->
                                        <!-- <li class="clickable"><a href="">Current Openings</a></li> -->
                                        <li class="clickable"><a href="" routerLink="/blogs">Blogs</a></li>
                                        <li class="clickable"><a href="https://youtu.be/hrxLhn7_CvY?si=OZk8Q5UjC9FIJ9Fh" target="_blank">Videos</a></li>
                                        <li class="clickable"><a (click)="navigateToTermsOfUse()">Terms of Uses</a></li>
                                        <li class="clickable"><a (click)="navigateToLicenses()">Licenses</a></li>
                                        <!-- <li class="clickable"><a (click)="navigateToFAQs()">FAQ</a></li> -->
                                        <li class="clickable"><a (click)="navigateToAboutUs()">About US</a></li>
                                        <li class="clickable"><a (click)="navigateToPrivacyPolicy()">Privacy Policy</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8 col-sm-6 col-6 mobile-foot-title-head remove-padd-mob">
                            <h6 class="foot-title-head">Contact Us</h6>
                            <div class="ft-contact-info">
                                <a href="tel:+919607925900"><img src="assets/images/new_images/call.svg" class=""
                                        alt="location">
                                    +91-9607925900 </a>
                                <!-- <a href="tel:+919870289050"><img src="assets/images/new_images/call.svg" class=""
                                        alt="location">
                                    +91-9870289050</a> -->
                                <a href="mailto:eflraftaarr.service@efl.co.in"> <img
                                        src="assets/images/new_images/mail.svg" class="" alt="location">
                                    eflraftaarr.service@efl.co.in</a>
                                <a href="#" (click)="openMap($event)"><img src="assets/images/new_images/location.svg" class="" alt="location">EFL
                                    RAFTAARR. Audumbar, 101/1, Erandwane, Dr. Ketkar Road, Pune, Maharashtra, <span
                                        style="display: block;">India - 411 004</span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 col-6 mobile-col-md-3 col-12 remove-padd-mob">

                    <div class="social-icon">

                        <div class="subscribe">
                            <h6 class="foot-title-head"> Subscribe</h6>
                            <p> Join our newsletter to stay up to date on features and releases. </p>

                            <form class="subscribeForms position-relative" [formGroup]="Subscribefrom"
                                (ngSubmit)="postSubscribefrom()">

                                <div class="row">
                                    <div class="col">
                                        <input type="email" class="form-control text-white email-input" placeholder="Please enter Your email Address"
                                            formControlName="email">
                                        <input type="submit" class="form-control submitbtn" name="submit">
                                    </div>
                                </div>

                            </form>
                            <div class="row">
                                <div class="col mt-4">
                                    <button type="button" class="btn colorwhite" (click)="patnerUS()"> Partner with Us</button>
                                </div>
                            </div>

                            <div class="appshow mt-4">
                                <img src="assets/images/apple_app_store.png" class="apple_app_store me-2" alt="apple">
                                <img src="assets/images/google_play_store.png" class="mobile-view-ios ms-2" alt="ios">
                            </div>

                        </div>


                    </div>

                </div>
                <div class="col-md-12 remove-padd-mob">
                    <div class="social-icon" style="padding-left: 0px;">
                        <div class="d-flex align-items-center" style="    border-bottom: 1px solid #FFFFFF1A;
    padding-bottom: 15px;">
                            <h6 class="foot-title-head m-0 me-sm-3 me-2">Follow us on:</h6>

                            <a href="https://www.facebook.com/Raftaarr.MSME?mibextid=JRoKGi" target="_blank"
                                class="me-2 me-sm-3 me-0 mobile-me-3">
                                <img src="assets/images/new_images/facebook.svg" width="26" height="26" alt="Twitter">
                            </a>
                            <a href="https://www.instagram.com/raftaarr_app?igsh=djQ4YXlpdGViMTR5" target="_blank"
                                class="me-2 me-sm-3 mobile-me-3">
                                <img src="assets/images/new_images/instagram.svg" width="26" height="26" alt="Twitter">
                            </a>

                            <a href="https://www.linkedin.com/company/efl-raftaarr/" target="_blank"
                                class="me-2 me-sm-3 mobile-me-3">
                                <img src="assets/images/new_images/bi_linkedin.svg" width="26" height="26" alt="Twitter"
                                    style="width: 20px;">
                            </a>
                            <a href="https://youtu.be/hrxLhn7_CvY?si=OZk8Q5UjC9FIJ9Fh" target="_blank" class="me-2 me-sm-3 mobile-me-3">
                                <img src="assets/images/new_images/youtube.svg" width="26" height="26" alt="Twitter"
                                    style="width: 24px;">
                            </a>
                            <!-- <a href="" target="_blank" class="me-2 me-sm-3 mobile-me-3">
                                <img src="assets/images/new_images/ft-x.svg" width="26" height="26" alt="Twitter"
                                    style="width: 24px;">
                            </a> -->
                        </div>

                        <div class="Copyright mt-sm-3 mt-2">
                            <p> Copyright © 2024-2025 EFL. All Rights Reserved. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</footer>